import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../allcss/blog7.css';
import blogImage from '../Asets/Blog.jpg';
import blog1 from '../Asets/blog47.png';
import Header from '../components/header';
import Footer from '../components/footer';

const Blog7 = () => {
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <div className="blog-section">
        {/* Hero Section */}
        <div
          className="blog-hero"
          style={{ backgroundImage: `url(${blogImage})` }}
        >
          <div className="blog-overlay">
            <h1 className="blog-title">Our Blog</h1>
            <p className="breadcrumb">
              <span
                style={{ cursor: 'pointer', color: '#fff' }}
                onClick={() => navigate('/')}
              >
                Home
              </span>
              <span> / Our Blog</span>
            </p>
          </div>
        </div>

        {/* Blog Detail */}
        <div className="blog-container">
          <h2 className="section-title">
            Why Holistic Education Matters – The Red School House Vadodara
          </h2>
          <br />
          <div className="published-badge">Published on: 18 August 2025</div>
          <br />

          <img
            src={blog1}
            alt="Holistic Education at Red School House Vadodara"
            className="blog-detail-img"
          />

          <div className="blog-detail-content">
            <p>
              <strong>Why Holistic Education Matters – The Red School House Approach</strong>
            </p>
            <p>
              Are you searching for the <strong>best pre school for all-round development in Vadodara</strong>? 
              At <strong>Red School House Vadodara</strong>, we believe that holistic education is the key 
              to preparing children for real-world success. Here’s how our unique approach nurtures every 
              child’s mind, body, and spirit.
            </p>

            <p><strong>What is Holistic Education?</strong></p>
            <p>
              Holistic education Vadodara is about more than textbooks and test scores. 
              At Red School House, we focus on <strong>intellectual growth, emotional well-being, 
              physical health, social skills, and creative expression</strong>. 
              Our aim is to shape compassionate and confident individuals ready for today’s world.
            </p>

            <p><strong>The Red School House Holistic Approach</strong></p>
            <ul>
              <li><strong>Academic Excellence:</strong> Our innovative teaching ensures deep understanding, critical thinking, and lifelong learning.</li>
              <li><strong>Emotional Support:</strong> Trained mentors and counselors help children build resilience, empathy, and a positive mindset.</li>
              <li><strong>Social & Leadership Skills:</strong> Group projects, events, and community programs teach students teamwork and leadership.</li>
              <li><strong>Physical Fitness:</strong> Daily sports, yoga, and wellness programs promote health and discipline.</li>
              <li><strong>Creative Growth:</strong> Art, music, dance, and drama let students discover talents and express themselves confidently.</li>
            </ul>

            <p><strong>Why Parents Choose Us</strong></p>
            <ul>
              <li><strong>Safe campus</strong> with modern facilities and caring faculty.</li>
              <li><strong>Comprehensive co-curricular</strong> and extracurricular opportunities.</li>
              <li><strong>Balanced focus</strong> on academics, sports, and creativity.</li>
              <li><strong>High parent and student satisfaction</strong> year after year.</li>
            </ul>

            <p><strong>Success Stories</strong></p>
            <p>
              “After joining Red School House, my child became more confident and creative. 
              The teachers truly care!” – <em>Parent Testimonial</em>
            </p>

            <p><strong>Frequently Asked Questions</strong></p>
            <p><strong>Q:</strong> How do I enroll my child at Red School House Vadodara?<br />
            <strong>A:</strong> Visit our Admissions Page for details and steps.</p>

            <p><strong>Q:</strong> What programs does the school offer for holistic education?<br />
            <strong>A:</strong> Learn more about our approach on our About Page.</p>

            <p><strong>Join Our Holistic Learning Community!</strong></p>
            <p>
              Ready to give your child the advantage of a <strong>holistic education</strong>? 
              Contact us today or schedule a campus visit. 
              Discover why Red School House Vadodara is the <strong>best school for all-round development</strong>.
            </p>

            {/* Go Back Button */}
            <div className="back-to-blogs-btn-wrapper">
              <button
                className="back-to-blogs-btn"
                onClick={() => navigate('/blog')}
              >
                Go Back To Blogs
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Blog7;
